<template lang="html">
<Tabs class="tabs" v-model="tabActive" animated swipeable type="line" title-inactive-color="#3b3b3b" title-tabActive-color="#fc2d2d" line-width="60">
    <Tab>
        <div slot="title">
            <span class="tab-name">
                服务介绍
            </span>
            <em class="tab-line" v-if="tabActive == 0" />
            <span class="van-tab-middle-line"></span>
        </div>
        <div class="timeBox">
            <span class="left" v-if="detail.service_estimated_time !== ''">预估耗时：{{ detail.service_estimated_time }}小时</span>
            <span class="right" v-if="detail.service_period !== ''">建议服务周期：{{ detail.service_period }}</span>
        </div>
        <div class="smallTitle">
            <span>服务详情</span>
        </div>

        <!-- 服务描述 -->
        <p class="serviceDetail">
            {{ detail.service_introduce.desc }}
        </p>

        <!-- 服务描述的图片 -->
        <div class="serviceImg">
            <img :key="item" v-for="item in detail.service_introduce.img" :src="item" />
        </div>

        <div
            class="smallTitle"
            v-if="detail.service_contrast_img.front_img !== '' && detail.service_contrast_img.later_img !== ''"
        >
            <span>服务前后对比</span>
        </div>

        <!-- 服务前后对比 -->
        <div
            class="comparison"
            v-if="detail.service_contrast_img.front_img !== '' && detail.service_contrast_img.later_img !== ''"
        >
            <div class="imgBox front">
                <img :src="detail.service_contrast_img.front_img" />
            </div>
            <div class="imgBox later">
                <img :src="detail.service_contrast_img.later_img" />
            </div>
        </div>

        <div class="smallTitle">
            <span>使用流程</span>
        </div>

        <div class="use">
            <img src="https://image.carisok.com/images/service_use.png" />
        </div>

        <div class="smallTitle">
            <span>到底了</span>
        </div>
    </Tab>
    <Tab>
        <div slot="title">
            服务须知
            <em class="tab-line" v-if="tabActive == 1" />
        </div>
        <div class="serviceNotice">
            {{ detail.service_process }}
        </div>
    </Tab>
</Tabs>
</template>

<script>
import {
    Tabs,
    Tab
} from 'vant'
export default {
    name: 'tabsBox',
    props: {
        /* 服务详情数据 */
        detail : {
            type: Object,
            default () {
                return {}
            }
        }
    },
    components: {
        Tabs,
        Tab
    },
    data () {
        return {
            tabActive: 0
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/stylus/variables.styl'
@import '~@/assets/stylus/mixin.styl'

.tabs
    .timeBox
        display flex
        justify-content space-between
        font-size 24px
        color #3b3b3b
        margin 60px 32px 0 32px
    .smallTitle
        position relative
        margin 50px 32px
        text-align center
        span
            color #999999
            font-size 28px
            display inline-block
            margin 0 auto
            text-align center
            background #fff
            line-height 42px
            z-index 20
            padding 0 24px
            position relative
        &:after
            content ''
            height 1PX
            display block
            top 18px
            z-index 10
            position absolute
            left 0
            width 100%
            background #efefef
    .serviceDetail
        font-size 24px
        color #3b3b3b
        margin 0 32px 38px 32px
    .comparison
        display flex
        justify-content space-between
        margin 0 32px 40px 32px
        .imgBox
            width 334px
            height 244px
            img
                display block
                width 100%
                height 100%
    .use
        margin 0 32px
    .serviceNotice
        margin 32px
        font-size 24px
        line-height 32px
        color #3b3b3b
</style>
